/**
 * YouTube Shorts Service for Sri Gnana Sai Baba Mandir
 * Channel: @srignanasaibabamandir
 * Total Verified Shorts: 236
 */

export const YOUTUBE_CHANNEL_HANDLE = "@srignanasaibabamandir";
export const YOUTUBE_CHANNEL_URL = "https://www.youtube.com/@srignanasaibabamandir";

/* Official Complete Collection of 236 Shorts from @srignanasaibabamandir Channel */
export const DEFAULT_SHORTS = [
  {
    "id": "short_1",
    "videoId": "Mrbvt9FuT30",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்கும் அற்புதங்கள் | வேண்டுதல்களை நிறைவேற்றும் சாய்பாபா",
    "embedUrl": "https://www.youtube-nocookie.com/embed/Mrbvt9FuT30?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/Mrbvt9FuT30/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_2",
    "videoId": "gRsazB6RtVI",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்கும் அற்புதம் | நினைத்ததை நிறைவேற்றும் சாய்நாதர் | ஓம் சாய் ராம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/gRsazB6RtVI?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/gRsazB6RtVI/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_3",
    "videoId": "6mw-uwpsIm0",
    "title": "நவக்கிரக ஹோமம் | ஒன்பது கிரகங்களின் அருளால் வாழ்வில் நன்மைகள் பெருகட்டும்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/6mw-uwpsIm0?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/6mw-uwpsIm0/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "pooja"
  },
  {
    "id": "short_4",
    "videoId": "o1MeKQ-_Du0",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் அற்புதம் | நினைத்ததை நிறைவேற்றும் அருள் | நம்பிக்கையின் ஆனந்தம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/o1MeKQ-_Du0?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/o1MeKQ-_Du0/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_5",
    "videoId": "LlzYKoPn6O4",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் ஆரத்தி தரிசனம் 🙏 பக்தர்களின் பேரானந்தம் | ஓம் சாய் ராம் 🕉️ #Shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/LlzYKoPn6O4?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/LlzYKoPn6O4/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "aarti"
  },
  {
    "id": "short_6",
    "videoId": "Znd9cKFs5Nw",
    "title": "வராகி ஹோமம் 🔥 அனைத்து விதமான வெற்றிகளையும் அருளும் அன்னை வராகியின் சக்திவாய்ந்த அருள் 🙏🌺",
    "embedUrl": "https://www.youtube-nocookie.com/embed/Znd9cKFs5Nw?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/Znd9cKFs5Nw/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "pooja"
  },
  {
    "id": "short_7",
    "videoId": "y-xvrT0fs08",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள்! ✨ | பக்தர்களின் உண்மை அனுபவங்கள்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/y-xvrT0fs08?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/y-xvrT0fs08/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_8",
    "videoId": "oqmlpsU0CQk",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள் 🙏 கேட்ட வரம் தரும் சாய்பாபா",
    "embedUrl": "https://www.youtube-nocookie.com/embed/oqmlpsU0CQk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/oqmlpsU0CQk/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_9",
    "videoId": "FgwiiHnVGr8",
    "title": "மெய்சிலிர்க்க வைக்கும் ஶ்ரீ ஞான சாய்பாபாவின் அற்புதம்! 🙏✨ | தேடி வந்தவருக்கு கிடைத்த பாக்கியம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/FgwiiHnVGr8?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/FgwiiHnVGr8/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_10",
    "videoId": "4UvIy7oDSjI",
    "title": "ஆயுள், ஆரோக்கியம், நீங்கா பெருமை அருளும் ஆயுஷ்ய ஹோமம் 🙏🔥 | ஶ்ரீ ஞான சாய்பாபா மந்திர், அம்பத்தூர்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/4UvIy7oDSjI?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/4UvIy7oDSjI/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "pooja"
  },
  {
    "id": "short_11",
    "videoId": "K8ZNCXj2Z1c",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்கும் அற்புதங்கள் | நினைத்ததை நிறைவேற்றும் சாய்பாபா 🙏",
    "embedUrl": "https://www.youtube-nocookie.com/embed/K8ZNCXj2Z1c?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/K8ZNCXj2Z1c/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_12",
    "videoId": "uiebOYWM-gM",
    "title": "தன்வந்திரி பகவான் ஹோமம் | உடல் & மன ஆரோக்கியம் அருளும் தன்வந்திரி மகாவிஷ்ணு ஹோமம் 🙏",
    "embedUrl": "https://www.youtube-nocookie.com/embed/uiebOYWM-gM?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/uiebOYWM-gM/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "pooja"
  },
  {
    "id": "short_13",
    "videoId": "T7Wm26vi6FM",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்கும் அற்புதம் | சாய்நாதனை தேடி வந்தவருக்கு கிடைத்த மகாபாக்கியம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/T7Wm26vi6FM?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/T7Wm26vi6FM/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_14",
    "videoId": "VPxVuG7uO2E",
    "title": "அமாவாசை கோ பூஜை | பித்ரு தோஷங்கள் நீங்கி முன்னோர்களின் ஆசி பெறும் அரிய வாய்ப்பு",
    "embedUrl": "https://www.youtube-nocookie.com/embed/VPxVuG7uO2E?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/VPxVuG7uO2E/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "pooja"
  },
  {
    "id": "short_15",
    "videoId": "g4UieWbStf8",
    "title": "திருஷ்டி தோஷங்கள் நீங்க திருஷ்டி துர்க்கை மூலமந்திர ஹோமம் | ஶ்ரீ ஞான சாய்நாதரின் பரிபூரண அருள்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/g4UieWbStf8?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/g4UieWbStf8/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "pooja"
  },
  {
    "id": "short_16",
    "videoId": "w1o8jXKBuic",
    "title": "ஸ்ரீ ஞான சாய்பாபா மந்திர், பக்தர்களின் அற்புதம்#அம்பத்தூர்#சென்னை#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/w1o8jXKBuic?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/w1o8jXKBuic/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_17",
    "videoId": "y98pWiWHoYE",
    "title": "ஸ்ரீ ஞான சாயி பாபா மந்திர் பக்தர்களுக்கு அற்புதம் நிகழ்த்திய ஞானசாய்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/y98pWiWHoYE?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/y98pWiWHoYE/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_18",
    "videoId": "4FcowNdkigk",
    "title": "பிரார்த்தனை பெட்டியின் மகிமை | பக்தர்களின் பிரச்சனைகளை தீர்க்கும் ஶ்ரீ ஞான சாய்பாபா | அம்பத்தூர்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/4FcowNdkigk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/4FcowNdkigk/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_19",
    "videoId": "5LIon4Uf4dg",
    "title": "குரு பௌர்ணமி | சத்தியநாராயண பூஜை 3 முறை | சாய்பாபா அருள் | ஶ்ரீ ஞான சாய்பாபா மந்திர்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/5LIon4Uf4dg?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/5LIon4Uf4dg/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "pooja"
  },
  {
    "id": "short_20",
    "videoId": "D0y0rRBGkek",
    "title": "கூட்டு பிரார்த்தனை 🙏 சாய்பாபா அருள் | குழந்தை பாக்கியம், வேலை, ஆரோக்கியம், வளம் பெற",
    "embedUrl": "https://www.youtube-nocookie.com/embed/D0y0rRBGkek?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/D0y0rRBGkek/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_21",
    "videoId": "olUdaLwmgjc",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள் | நினைத்ததை நிறைவேற்றும் சாய்பாபா | Chennai",
    "embedUrl": "https://www.youtube-nocookie.com/embed/olUdaLwmgjc?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/olUdaLwmgjc/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_22",
    "videoId": "7emgpqRJubA",
    "title": "வயோதிக வியாதிகளில் இருந்து விடுதலை | கூட்டு பிரார்த்தனை | நோய்கள் குணமாக | ஶ்ரீ ஞான சாய்பாபா",
    "embedUrl": "https://www.youtube-nocookie.com/embed/7emgpqRJubA?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/7emgpqRJubA/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_23",
    "videoId": "IIqSjD3MkAk",
    "title": "கூட்டு பிரார்த்தனை 🙏 சிறப்புக் குழந்தைகளுக்காக ❤️ | கடவுளின் குழந்தைகளுக்கான இறை பிரார்த்தனை",
    "embedUrl": "https://www.youtube-nocookie.com/embed/IIqSjD3MkAk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/IIqSjD3MkAk/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_24",
    "videoId": "KrEsMFrScF4",
    "title": "சொர்ண ஆகர்ஷண பைரவ ஹோமம் 🙏🔥 | Business & Career Growth Blessings | Sri Gnana Sai Baba Mandir",
    "embedUrl": "https://www.youtube-nocookie.com/embed/KrEsMFrScF4?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/KrEsMFrScF4/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "pooja"
  },
  {
    "id": "short_25",
    "videoId": "4Q9Y38bSsiw",
    "title": "சத்யநாராயண பூஜையின் மகிமை 🙏 | ஶ்ரீ ஞான சாய்பாபா மந்திர், அம்பத்தூர் சென்னை",
    "embedUrl": "https://www.youtube-nocookie.com/embed/4Q9Y38bSsiw?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/4Q9Y38bSsiw/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "pooja"
  },
  {
    "id": "short_26",
    "videoId": "foX4FDK_xio",
    "title": "துனி பூஜை 🔥 நவதானியம் வைத்து வழிபடலாம் 🙏 குழந்தை பாக்கியம் அருளும் சாய்நாதர் | Sai Baba Blessings",
    "embedUrl": "https://www.youtube-nocookie.com/embed/foX4FDK_xio?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/foX4FDK_xio/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "pooja"
  },
  {
    "id": "short_27",
    "videoId": "DcJ3HDiDv6g",
    "title": "காது கேட்கும் ஶ்ரீ ஞான சாய்நாதர் 🙏 நம்பிக்கை வையுங்கள்… நிச்சயம் நடக்கும்!",
    "embedUrl": "https://www.youtube-nocookie.com/embed/DcJ3HDiDv6g?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/DcJ3HDiDv6g/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_28",
    "videoId": "dNYA5XT4ECE",
    "title": "❤️ இதய நோயிலிருந்து மீட்ட ஶ்ரீ ஞான சாய்நாதர் 🙏 | சாய்பாபாவின் வல்லமை | Sai Baba Miracle ✨ #Shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/dNYA5XT4ECE?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/dNYA5XT4ECE/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_29",
    "videoId": "nYPWUKzPko8",
    "title": "சத்யநாராயண பூஜையின் பலன் 🙏 கேட்ட வரம் தரும் ஶ்ரீ ஞான சாய்பாபா ✨ நினைத்ததை நிறைவேற்றும் சாய்பாபா 🌸",
    "embedUrl": "https://www.youtube-nocookie.com/embed/nYPWUKzPko8?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/nYPWUKzPko8/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "pooja"
  },
  {
    "id": "short_30",
    "videoId": "96MQI2SJuT8",
    "title": "நினைத்ததை நிறைவேற்றும் ஶ்ரீ ஞான சாய்பாபா 🙏✨ | ஓம் சாய் ராம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/96MQI2SJuT8?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/96MQI2SJuT8/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_31",
    "videoId": "0nL7d9V8dWs",
    "title": "திருமணத் தடைகள் நீங்கி நல்ல வரன் அமைய அருளும் சுயம்வர கலா பார்வதி ஹோமம் | ஶ்ரீ ஞான சாய்பாபா மந்திர்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/0nL7d9V8dWs?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/0nL7d9V8dWs/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "pooja"
  },
  {
    "id": "short_32",
    "videoId": "V-Le6cZQ7V4",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்கும் அற்புதங்கள் 🙏✨ | நினைத்ததை நிறைவேற்றும் சாய்பாபா",
    "embedUrl": "https://www.youtube-nocookie.com/embed/V-Le6cZQ7V4?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/V-Le6cZQ7V4/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_33",
    "videoId": "lpoEUUH8RcU",
    "title": "🪷 லக்ஷ்மி குபேரர் ஹோமம் 🙏✨ | செல்வ வளம் பெருக, வியாபாரம் சிறக்க | ஶ்ரீ ஞான சாய்பாபா மந்திர்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/lpoEUUH8RcU?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/lpoEUUH8RcU/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "pooja"
  },
  {
    "id": "short_34",
    "videoId": "FKSXO3WS9ig",
    "title": "🙏 ஶ்ரீ ஞான சாய்பாபாவின் ஆரத்தி தரிசனம் & ஆசிர்வாதம் | Sri Gnana Sai Baba Mandir | #Shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/FKSXO3WS9ig?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/FKSXO3WS9ig/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "aarti"
  },
  {
    "id": "short_35",
    "videoId": "UFswnjvz64E",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள் 🙏 | Ambattur Chennai | #Shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/UFswnjvz64E?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/UFswnjvz64E/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_36",
    "videoId": "7NvYU-CDNnc",
    "title": "உணவே பிரம்மம் 🙏 | தூய்மை பணியாளர்களுக்கு அன்னதானம் | ஶ்ரீ ஞான சாய்பாபா மந்திர், அம்பத்தூர் சென்னை",
    "embedUrl": "https://www.youtube-nocookie.com/embed/7NvYU-CDNnc?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/7NvYU-CDNnc/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "annadanam"
  },
  {
    "id": "short_37",
    "videoId": "uPHcIYPQRlA",
    "title": "விக்னராஜ கணபதி ஹோமம் 🙏 | காரியத் தடைகள் நீங்கி வெற்றி பெற | ஸ்ரீ ஞான சாய்பாபா மந்திர், அம்பத்தூர்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/uPHcIYPQRlA?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/uPHcIYPQRlA/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "pooja"
  },
  {
    "id": "short_38",
    "videoId": "MKkVZOdgrBo",
    "title": "காது கேட்கும் ஶ்ரீ ஞான சாய்பாபாவின் மகிமை | Ambattur Chennai | Sri Gnana Sai Baba Mandir 🙏✨",
    "embedUrl": "https://www.youtube-nocookie.com/embed/MKkVZOdgrBo?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/MKkVZOdgrBo/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_39",
    "videoId": "ckYKb9gxunY",
    "title": "கோ பூஜை | பித்ரு தோஷங்கள் நீங்கும் | கர்ம வினைகள் விலகும் | தெய்வீக வழிபாட்டின் மகிமை 🐄🙏",
    "embedUrl": "https://www.youtube-nocookie.com/embed/ckYKb9gxunY?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/ckYKb9gxunY/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "pooja"
  },
  {
    "id": "short_40",
    "videoId": "oYontB_LSDo",
    "title": "கோ பூஜையின் தரிசனம், மஹாலக்ஷ்மியின் அருள் பெறும் புனித தருணம் | அம்பத்தூர் ஶ்ரீ ஞான சாய்பாபா மந்திர்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/oYontB_LSDo?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/oYontB_LSDo/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "pooja"
  },
  {
    "id": "short_41",
    "videoId": "sv3fhG4e-JY",
    "title": "🪔 ஸ்ரீ ஞான சாய்பாபா அபிஷேக தரிசனம் 🪔Sri Gnana Sai Baba Mandir | Sri Gnana Sai Baba Temple Chennai",
    "embedUrl": "https://www.youtube-nocookie.com/embed/sv3fhG4e-JY?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/sv3fhG4e-JY/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_42",
    "videoId": "BzPcEtqNgcQ",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள் | அம்பத்தூர், சென்னை 🙏✨ #Shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/BzPcEtqNgcQ?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/BzPcEtqNgcQ/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_43",
    "videoId": "B4nAnNC9wR4",
    "title": "ஶ்ரீ ஞான சாய்பாபா மந்திர் அம்பத்தூர் சென்னை | சத்யநாராயண பூஜை | நினைத்தது நிறைவேறும் 🙏✨ #Shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/B4nAnNC9wR4?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/B4nAnNC9wR4/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "pooja"
  },
  {
    "id": "short_44",
    "videoId": "8U-xGWXGQhM",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் கூட்டு பிரார்த்தனை | சாய்நாதரின் அருளால் ஆரோக்கியம் பெறுவோம் #omsairam #shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/8U-xGWXGQhM?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/8U-xGWXGQhM/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_45",
    "videoId": "EZDvcP7vK7s",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் ஆசிர்வாதம் பரிபூரணம் 🙏🏻 | அம்பத்தூர் , சென்னை #omsairam #saibaba #shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/EZDvcP7vK7s?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/EZDvcP7vK7s/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_46",
    "videoId": "VLSVBwBuSFY",
    "title": "சத்யநாராயண பூஜை 🙏 ஜூலை 29 | ஶ்ரீ ஞான சாய்பாபா மந்திர் #சத்யநாராயணபூஜை #omsairam #saibaba #pooja",
    "embedUrl": "https://www.youtube-nocookie.com/embed/VLSVBwBuSFY?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/VLSVBwBuSFY/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "pooja"
  },
  {
    "id": "short_47",
    "videoId": "jZzyBG9L1iY",
    "title": "காது கேட்கும் ஶ்ரீ ஞான சாய்பாபாவின் மகிமை | அம்பத்தூர், சென்னை #shorts #omsairam #saibaba",
    "embedUrl": "https://www.youtube-nocookie.com/embed/jZzyBG9L1iY?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/jZzyBG9L1iY/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_48",
    "videoId": "nAQF1EqqHmk",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் ஆரத்தி 🙏 | இல்லங்களில் மகிழ்ச்சி, அமைதி#SaiBaba #YouTubeShorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/nAQF1EqqHmk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/nAQF1EqqHmk/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "aarti"
  },
  {
    "id": "short_49",
    "videoId": "qgnhU0CCyQs",
    "title": "சத்யநாராயணர் விக்ரகம் பக்தர்களின் பங்களிப்பு அவசியம் | ஶ்ரீ ஞான சாய்பாபா மந்திர் #Satyanarayanan",
    "embedUrl": "https://www.youtube-nocookie.com/embed/qgnhU0CCyQs?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/qgnhU0CCyQs/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_50",
    "videoId": "SLO5NyTVu7k",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள் | அம்பத்தூர், சென்னை #SaiBaba #Shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/SLO5NyTVu7k?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/SLO5NyTVu7k/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_51",
    "videoId": "FjMFZrN8ROk",
    "title": "நினைத்ததை நிறைவேற்றும் ஶ்ரீ ஞான சாய்பாபா 🙏🏻 | அம்பத்தூர், சென்னை #SaiBaba #OmSaiRam #Shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/FjMFZrN8ROk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/FjMFZrN8ROk/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_52",
    "videoId": "oGl82VayLaE",
    "title": "நமது ஶ்ரீ ஞான சாய்பாபாவின் ஆசிர்வாதம் பரிபூரணம் 🙏🏻 #SaiBaba #OmSaiRam #Shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/oGl82VayLaE?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/oGl82VayLaE/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_53",
    "videoId": "pzOrKsHOf3w",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள் | அம்பத்தூர் சென்னை #omsairam #saimiracle",
    "embedUrl": "https://www.youtube-nocookie.com/embed/pzOrKsHOf3w?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/pzOrKsHOf3w/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_54",
    "videoId": "RnJDugGzIHY",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள் | அம்பத்தூர் சென்னை #omsairam #saimiracle",
    "embedUrl": "https://www.youtube-nocookie.com/embed/RnJDugGzIHY?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/RnJDugGzIHY/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_55",
    "videoId": "z7hGDFW1zn0",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள் | அம்பத்தூர் சென்னை #omsairam #saimiracle",
    "embedUrl": "https://www.youtube-nocookie.com/embed/z7hGDFW1zn0?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/z7hGDFW1zn0/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_56",
    "videoId": "VxCAGjM_r-g",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள் | அம்பத்தூர் சென்னை #omsairam #saimiracle",
    "embedUrl": "https://www.youtube-nocookie.com/embed/VxCAGjM_r-g?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/VxCAGjM_r-g/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_57",
    "videoId": "bU-T0Tb2KP4",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள் | அம்பத்தூர் சென்னை #omsairam #saimiracle",
    "embedUrl": "https://www.youtube-nocookie.com/embed/bU-T0Tb2KP4?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/bU-T0Tb2KP4/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_58",
    "videoId": "nbLZNh_smws",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் ஆரத்தியை கண்டு பக்தர்கள் பேரானந்தம் #shorts #omsairam #Ambattur #chennai",
    "embedUrl": "https://www.youtube-nocookie.com/embed/nbLZNh_smws?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/nbLZNh_smws/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "aarti"
  },
  {
    "id": "short_59",
    "videoId": "QAnNKD_Cj7Y",
    "title": "அம்பத்தூர் சென்னையில் ஶ்ரீ ஞான சாய்பாபா கோவிலில் சிவபெருமானுக்கு அபிஷேகம் நடைபெற்றது #shorts #சிவாய",
    "embedUrl": "https://www.youtube-nocookie.com/embed/QAnNKD_Cj7Y?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/QAnNKD_Cj7Y/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_60",
    "videoId": "YNwrmvL2oZ8",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள் | அம்பத்தூர், சென்னை. #omsairam #shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/YNwrmvL2oZ8?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/YNwrmvL2oZ8/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_61",
    "videoId": "bVxJmEFZbLY",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள் | அம்பத்தூர் சென்னை #omsairam #saimiracle",
    "embedUrl": "https://www.youtube-nocookie.com/embed/bVxJmEFZbLY?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/bVxJmEFZbLY/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_62",
    "videoId": "F_54qI3Fzn8",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள் | அம்பத்தூர், சென்னை #shorts #omsairam",
    "embedUrl": "https://www.youtube-nocookie.com/embed/F_54qI3Fzn8?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/F_54qI3Fzn8/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_63",
    "videoId": "Uzjba5359iY",
    "title": "செல்வமும் செழிப்பும் நாளும் உங்கள் வாழ்வில் மலரட்டும் | ஶ்ரீ ஞான சாய்பாபா மந்திர் சென்னை 🙏 #SaiBaba",
    "embedUrl": "https://www.youtube-nocookie.com/embed/Uzjba5359iY?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/Uzjba5359iY/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_64",
    "videoId": "UipgplcArws",
    "title": "சத்யநாராயண பூஜை தரிசனத்தின் பலன் | ஶ்ரீ ஞான சாய்பாபா மந்திர் #Shorts #SatyanarayanaPooja",
    "embedUrl": "https://www.youtube-nocookie.com/embed/UipgplcArws?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/UipgplcArws/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "pooja"
  },
  {
    "id": "short_65",
    "videoId": "dZ6YlGKHOL8",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் தாரக மந்திரம் | நம்பிக்கை & பொறுமை 🙏 #Shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/dZ6YlGKHOL8?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/dZ6YlGKHOL8/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_66",
    "videoId": "7AxlIWGWPOo",
    "title": "சத்யநாராயண பூஜை | ஶ்ரீ ஞான சாய்பாபா மந்திர்,அம்பத்தூர் சென்னை #SatyanarayanaPooja #shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/7AxlIWGWPOo?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/7AxlIWGWPOo/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "pooja"
  },
  {
    "id": "short_67",
    "videoId": "F5BFUUV1OTM",
    "title": "சாய்பாபா அருளால் குடும்ப ஒற்றுமை பெற சிறப்பு கூட்டு பிரார்த்தனை 🌺🙏#OmSaiRam #SaiBlessings #SaiBaba",
    "embedUrl": "https://www.youtube-nocookie.com/embed/F5BFUUV1OTM?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/F5BFUUV1OTM/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_68",
    "videoId": "-JqONIjlKYo",
    "title": "🙏 மாணவர்களின் வெற்றிக்கான சிறப்பு கூட்டு பிரார்த்தனை | ஶ்ரீ ஞான சாய்பாபா மந்திர் #SaiBaba #shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/-JqONIjlKYo?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/-JqONIjlKYo/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_69",
    "videoId": "45tfvlMn8Yk",
    "title": "வைகாசி விசாகம் | முருகன் வள்ளி தெய்வானை தீப ஆராதனை | ஶ்ரீ ஞான சாய்பாபா மந்திர் #chennai  #shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/45tfvlMn8Yk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/45tfvlMn8Yk/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_70",
    "videoId": "apHJxJEj2d4",
    "title": "காது கேட்கும் ஶ்ரீ ஞான சாய்பாபாவின் மகிமை | அம்பத்தூர், சென்னை #omsairam #chennai #ambattur #shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/apHJxJEj2d4?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/apHJxJEj2d4/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_71",
    "videoId": "3RqezHois2Y",
    "title": "சாய்பாபா ஆரத்தி தரிசனம் | ஶ்ரீ ஞான சாய்பாபா மந்திர் | Ambattur Chennai #OmSaiRam #SaiBaba #Shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/3RqezHois2Y?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/3RqezHois2Y/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "aarti"
  },
  {
    "id": "short_72",
    "videoId": "gRRgU8uvcBE",
    "title": "காது கேட்கும் ஶ்ரீ ஞான சாய்பாபாவின் மகிமை | சென்னை #ambattur #chennai #shorts #trendingshorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/gRRgU8uvcBE?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/gRRgU8uvcBE/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_73",
    "videoId": "hjuowR2jgzM",
    "title": "காது கேட்கும் ஶ்ரீ ஞான சாய்பாபாவின் மகிமை | அம்பத்தூர் | சென்னை #omsairam #shorts #chennai",
    "embedUrl": "https://www.youtube-nocookie.com/embed/hjuowR2jgzM?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/hjuowR2jgzM/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_74",
    "videoId": "APOR8ebhaSk",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள் | அம்பத்தூர் சென்னை #omsairam #saimiracle",
    "embedUrl": "https://www.youtube-nocookie.com/embed/APOR8ebhaSk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/APOR8ebhaSk/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_75",
    "videoId": "ZzNKGcPQXZQ",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள் | அம்பத்தூர், சென்னை.#shortsvideo #omsairam",
    "embedUrl": "https://www.youtube-nocookie.com/embed/ZzNKGcPQXZQ?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/ZzNKGcPQXZQ/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_76",
    "videoId": "ftEz2sOa6fo",
    "title": "முருகனின் வைகாசி விசாக திருநாள் சிறப்பு பூஜை | ஸ்ரீ ஞான சாய்பாபா மந்திர் சென்னை #murugan #shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/ftEz2sOa6fo?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/ftEz2sOa6fo/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "pooja"
  },
  {
    "id": "short_77",
    "videoId": "N9myCiLRuyc",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள் | அம்பத்தூர், சென்னை. #omsairam #shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/N9myCiLRuyc?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/N9myCiLRuyc/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_78",
    "videoId": "SyteVlwypP8",
    "title": "நமது ஞான சாய்பாபாவின் ஆசிர்வாதம் பரிபூரணம் | ஶ்ரீ ஞான சாய்பாபா மந்திர் | அம்பத்தூர்,சென்னை #omsairam",
    "embedUrl": "https://www.youtube-nocookie.com/embed/SyteVlwypP8?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/SyteVlwypP8/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_79",
    "videoId": "Dqr79f43ELg",
    "title": "உலகம் முழுவதும் அமைதி மலர ஶ்ரீ ஞான சாய்பாபாவின் ஆசிர்வாதம் | அம்பத்தூர் | சென்னை",
    "embedUrl": "https://www.youtube-nocookie.com/embed/Dqr79f43ELg?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/Dqr79f43ELg/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_80",
    "videoId": "vfTdpqKFAbc",
    "title": "காது கேட்கும் ஶ்ரீ ஞான சாய்பாபாவின் மகிமை | அம்பத்தூர் சென்னை #SaiBaba #OmSaiRam #Shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/vfTdpqKFAbc?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/vfTdpqKFAbc/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_81",
    "videoId": "wquaqRYIJZw",
    "title": "இழந்த பணத்தை மீட்டுக்கொடுத்த ஶ்ரீ ஞான சாய்பாபா | அம்பத்தூர் சென்னை #SaiBaba #OmSaiRam #Shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/wquaqRYIJZw?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/wquaqRYIJZw/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_82",
    "videoId": "7JFJyhyzROg",
    "title": "பாபாவுக்கு பாலபிஷேகம் | ஶ்ரீ ஞான சாய்பாபா மந்திர் அம்பத்தூர் | பக்தி தருணம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/7JFJyhyzROg?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/7JFJyhyzROg/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_83",
    "videoId": "8k0qvfCCUjI",
    "title": "ஞான சாய்நாதனை தேடி வந்தவருக்கு கிடைத்த பாக்கியம் | அம்பத்தூர் | ஶ்ரீ ஞான சாய்பாபா மந்திர் ✨🙏🏻",
    "embedUrl": "https://www.youtube-nocookie.com/embed/8k0qvfCCUjI?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/8k0qvfCCUjI/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_84",
    "videoId": "Gqogzqbxdzs",
    "title": "“கோமாதா அருளால் வளம் பெருகும் வாழ்க்கை | ஶ்ரீ ஞான சாய்பாபா மந்திர், அம்பத்தூர் – தெய்வீக அனுபவம்”",
    "embedUrl": "https://www.youtube-nocookie.com/embed/Gqogzqbxdzs?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/Gqogzqbxdzs/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_85",
    "videoId": "nSP1fJJv6kY",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள் ✨🙏🏻| அம்பத்தூர் | ஶ்ரீ ஞான சாய்பாபா மந்திர்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/nSP1fJJv6kY?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/nSP1fJJv6kY/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_86",
    "videoId": "xcgiO77k-yY",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள் | அம்பத்தூர் | Shorts",
    "embedUrl": "https://www.youtube-nocookie.com/embed/xcgiO77k-yY?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/xcgiO77k-yY/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_87",
    "videoId": "RQHWbCTVQ5w",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்க வைக்கும் அற்புதங்கள் ✨🙏🏻",
    "embedUrl": "https://www.youtube-nocookie.com/embed/RQHWbCTVQ5w?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/RQHWbCTVQ5w/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_88",
    "videoId": "8UguEBbDWps",
    "title": "காது கேட்கும் ஶ்ரீ ஞான சாய்பாபாவின் மகிமை | நம்பினால் நடக்கும் அற்புதங்கள் | Sai Baba Miracles Tamil",
    "embedUrl": "https://www.youtube-nocookie.com/embed/8UguEBbDWps?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/8UguEBbDWps/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_89",
    "videoId": "mvXcEMTHJSE",
    "title": "உலகப்போர் நிறுத்தம் வேண்டி ஶ்ரீ ஞான சாய்பாபா கோவிலில் ஒன்பது மட்ட தேங்காய் பூஜை ✨🙏🏻",
    "embedUrl": "https://www.youtube-nocookie.com/embed/mvXcEMTHJSE?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/mvXcEMTHJSE/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "pooja"
  },
  {
    "id": "short_90",
    "videoId": "xOOa3jCiZnk",
    "title": "🌟 ஸ்ரீ ஞானசாய்பாபாவின் அதிசய அற்புதங்கள் 🙏 | Powerful Sai Baba Miracles You Must See ❤️✨",
    "embedUrl": "https://www.youtube-nocookie.com/embed/xOOa3jCiZnk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/xOOa3jCiZnk/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_91",
    "videoId": "kOBAL-6AZhM",
    "title": "மட்ட தேங்காய் பூஜையின் மகிமை 🙏 | Gnanasaibaba அருள் அனுபவம் | சக்தி வாய்ந்த ஆன்மீக ரகசியம் ✨",
    "embedUrl": "https://www.youtube-nocookie.com/embed/kOBAL-6AZhM?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/kOBAL-6AZhM/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "pooja"
  },
  {
    "id": "short_92",
    "videoId": "w0A7kAOiipY",
    "title": "காது கேட்கும் ஶ்ரீ ஞான சாய்பாபாவின் மகிமை | நம்பினால் நடக்கும் அற்புதங்கள் | Sai Baba Miracles Tamil",
    "embedUrl": "https://www.youtube-nocookie.com/embed/w0A7kAOiipY?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/w0A7kAOiipY/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_93",
    "videoId": "LzPdMtPKvXI",
    "title": "சிறப்பு சத்யநாராயண பூஜை – மே 30 & 31 | அருள் தரும் புனித நிகழ்வு | Sri Sathyanarayana Pooja Live ✨🙏🏻",
    "embedUrl": "https://www.youtube-nocookie.com/embed/LzPdMtPKvXI?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/LzPdMtPKvXI/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "pooja"
  },
  {
    "id": "short_94",
    "videoId": "eL5Q4TDfGEY",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்கவைக்கும் அற்புதங்கள் ❤️🙏🏻",
    "embedUrl": "https://www.youtube-nocookie.com/embed/eL5Q4TDfGEY?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/eL5Q4TDfGEY/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_95",
    "videoId": "aoLZcIEOFwc",
    "title": "ஶ்ரீ ஞான சாய்பாபா மந்திர் – புனித அபிஷேக நிகழ்வுகள் ❤️🙏🏻",
    "embedUrl": "https://www.youtube-nocookie.com/embed/aoLZcIEOFwc?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/aoLZcIEOFwc/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_96",
    "videoId": "LwGc0iaCPUQ",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்கவைக்கும் அற்புதங்கள் ❤️🙏🏻",
    "embedUrl": "https://www.youtube-nocookie.com/embed/LwGc0iaCPUQ?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/LwGc0iaCPUQ/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_97",
    "videoId": "r0Ym7homFN0",
    "title": "காது கேட்கும் ஶ்ரீ ஞான சாய்பாபாவின் மகிமை 🙏🏻❤️",
    "embedUrl": "https://www.youtube-nocookie.com/embed/r0Ym7homFN0?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/r0Ym7homFN0/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_98",
    "videoId": "5VxCb4Wl_9M",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்கவைக்கும் அற்புதங்கள் 🙏🏻 #omsairam #astrology #saibabablessings",
    "embedUrl": "https://www.youtube-nocookie.com/embed/5VxCb4Wl_9M?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/5VxCb4Wl_9M/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_99",
    "videoId": "VHRwHmjoeu4",
    "title": "Ambattur Sri Gnana Sai Baba Miracle 🙏✨ | சாய்பாபா அற்புதம் 💫 #omsairam #shirdisaibabadevotees",
    "embedUrl": "https://www.youtube-nocookie.com/embed/VHRwHmjoeu4?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/VHRwHmjoeu4/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_100",
    "videoId": "dDOI9bKH-hc",
    "title": "சித்ரா பௌர்ணமி அன்னதானம் 2026 | சாய்பாபாவின் அற்புதங்கள் 🙏 | அம்பத்தூர் ஸ்ரீ ஞான சாய்பாபா மந்திர்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/dDOI9bKH-hc?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/dDOI9bKH-hc/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "annadanam"
  },
  {
    "id": "short_101",
    "videoId": "WbNZy0egdv0",
    "title": "ஶ்ரீ ஞான சாய்பாபாவின் மெய்சிலிர்க்கவைக்கும் அற்புதங்கள் 🙏🏻 #omsairam #astrology #saibabablessings",
    "embedUrl": "https://www.youtube-nocookie.com/embed/WbNZy0egdv0?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/WbNZy0egdv0/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_102",
    "videoId": "DEc7IZQeSUk",
    "title": "பாம்பு ரூபதில் காட்சி கொடுத்த ஸ்ரீ ஞான சாய்பாபா 😯🙏#saibabablessings #omsairam #devotional",
    "embedUrl": "https://www.youtube-nocookie.com/embed/DEc7IZQeSUk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/DEc7IZQeSUk/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_103",
    "videoId": "5XTecl_rXyQ",
    "title": "மெய் சிலிர்க்கவைக்கும் ஸ்ரீ  ஞான சாய்பாபாவின் அற்புதங்கள் ❤️🙏#saibabablessings #omsairam #devotional",
    "embedUrl": "https://www.youtube-nocookie.com/embed/5XTecl_rXyQ?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/5XTecl_rXyQ/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_104",
    "videoId": "3KlhCPVvkRk",
    "title": "மெய் சிலிர்க்கவைக்கும் ஸ்ரீ  ஞான சாய்பாபாவின் அற்புதங்கள் ❤️🙏#saibabablessings #omsairam #devotional",
    "embedUrl": "https://www.youtube-nocookie.com/embed/3KlhCPVvkRk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/3KlhCPVvkRk/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_105",
    "videoId": "Dcwin6pUdus",
    "title": "மே - 1 சத்திய நாராயண பூஜையுடன் ,சித்ரா பௌர்ணமி அன்னதானம் 🙏 #saibabablessings #omsairam #devotional",
    "embedUrl": "https://www.youtube-nocookie.com/embed/Dcwin6pUdus?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/Dcwin6pUdus/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "annadanam"
  },
  {
    "id": "short_106",
    "videoId": "03qcAKZgNsk",
    "title": "மே - 1 சத்திய நாராயண பூஜையுடன் ,சித்ரா பௌர்ணமி அன்னதானம் 🙏 #saibabablessings #omsairam #devotional",
    "embedUrl": "https://www.youtube-nocookie.com/embed/03qcAKZgNsk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/03qcAKZgNsk/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "annadanam"
  },
  {
    "id": "short_107",
    "videoId": "IppLpRpDYOk",
    "title": "வேண்டுதலை நிறைவேற்றும் ஸ்ரீ ஞான சாய்பாபா 🙏❤️#saibabablessings #omsairam #devotional",
    "embedUrl": "https://www.youtube-nocookie.com/embed/IppLpRpDYOk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/IppLpRpDYOk/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_108",
    "videoId": "7LtCOXol47A",
    "title": "குழந்தை வரம் அருளிய ஸ்ரீ ஞான சாய்பாபா  🙏❤️#saibabablessings #omsairam #devotional",
    "embedUrl": "https://www.youtube-nocookie.com/embed/7LtCOXol47A?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/7LtCOXol47A/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_109",
    "videoId": "eIA6v-kdoi4",
    "title": "வேண்டுதலை நிறைவேற்றும் ஸ்ரீ ஞான சாய்பாபா 🙏❤️#saibabablessings #omsairam #devotional",
    "embedUrl": "https://www.youtube-nocookie.com/embed/eIA6v-kdoi4?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/eIA6v-kdoi4/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_110",
    "videoId": "ZfCzjOudAbQ",
    "title": "வேண்டுதலை நிறைவேற்றும் ஸ்ரீ ஞான சாய்பாபா 🙏🥺❤️#saibabablessings #omsairam #devotional",
    "embedUrl": "https://www.youtube-nocookie.com/embed/ZfCzjOudAbQ?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/ZfCzjOudAbQ/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_111",
    "videoId": "bivr-0Q7R-k",
    "title": "ஸ்ரீ ஞான சாய்பாபாவின் மகிமை பக்தர்கள் மகிழ்ச்சி   🙏🥺❤️#saibabablessings #omsairam #devotional",
    "embedUrl": "https://www.youtube-nocookie.com/embed/bivr-0Q7R-k?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/bivr-0Q7R-k/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_112",
    "videoId": "CqwoXWyM-qU",
    "title": "ஸ்ரீ ஞானசாய்பாபாவின் அற்புதம் 🙏🥺#shirdisaibaba #devotion #omsairam",
    "embedUrl": "https://www.youtube-nocookie.com/embed/CqwoXWyM-qU?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/CqwoXWyM-qU/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_113",
    "videoId": "jNoqgYDPFwU",
    "title": "நினைத்ததை நடத்தித் தரும் ஸ்ரீ ஞான சாய்பாபா 🙏🥺#shirdisaibaba #astrology #devotion #omsairam",
    "embedUrl": "https://www.youtube-nocookie.com/embed/jNoqgYDPFwU?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/jNoqgYDPFwU/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_114",
    "videoId": "uVEYOIMG84Q",
    "title": "காது கேட்கும் ஞான சாய்பாபா..",
    "embedUrl": "https://www.youtube-nocookie.com/embed/uVEYOIMG84Q?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/uVEYOIMG84Q/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_115",
    "videoId": "ya9tS9MV1kQ",
    "title": "ஸ்ரீ ராம நவமி விழா🙏 ஞான சாய்பாபா மந்திர்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/ya9tS9MV1kQ?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/ya9tS9MV1kQ/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_116",
    "videoId": "VmrG0hqGVJw",
    "title": "அற்புதத்தை அள்ளித் தரும் பாபா 🙏",
    "embedUrl": "https://www.youtube-nocookie.com/embed/VmrG0hqGVJw?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/VmrG0hqGVJw/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_117",
    "videoId": "KE27L5wdIIo",
    "title": "குழந்தை வரம் தரும் ஞான சாய் பாபா",
    "embedUrl": "https://www.youtube-nocookie.com/embed/KE27L5wdIIo?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/KE27L5wdIIo/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_118",
    "videoId": "1AcOlxAdqXA",
    "title": "பக்தர்களுக்கு ஸ்ரீ ஞான சாய்பாபா அருளிய அற்புதங்கள் 🙏 ❤️#saibabablessings #omsairam #devotional",
    "embedUrl": "https://www.youtube-nocookie.com/embed/1AcOlxAdqXA?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/1AcOlxAdqXA/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_119",
    "videoId": "9lqrgfkSzIk",
    "title": "ஞான சாய்பாபா🙏 அற்புதம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/9lqrgfkSzIk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/9lqrgfkSzIk/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_120",
    "videoId": "XLprvDl0grA",
    "title": "சிவாய நமஹ, திருமந்திரம், உணவே பிரம்மம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/XLprvDl0grA?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/XLprvDl0grA/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "annadanam"
  },
  {
    "id": "short_121",
    "videoId": "FOXhfbOUAj8",
    "title": "மழலை செல்வம் அருளும் சாய் பாபா 🙏",
    "embedUrl": "https://www.youtube-nocookie.com/embed/FOXhfbOUAj8?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/FOXhfbOUAj8/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_122",
    "videoId": "v1W4WRtQC0c",
    "title": "துனி எனும் புனித நெருப்பு 🙏",
    "embedUrl": "https://www.youtube-nocookie.com/embed/v1W4WRtQC0c?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/v1W4WRtQC0c/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_123",
    "videoId": "zxVyhv4M0-c",
    "title": "கர்ம வினைகள், பித்ரு சாபங்கள், விலகும்,",
    "embedUrl": "https://www.youtube-nocookie.com/embed/zxVyhv4M0-c?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/zxVyhv4M0-c/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_124",
    "videoId": "qWElBqsgOys",
    "title": "ஞான சாய்பாபாவின் அற்புதம் 🙏",
    "embedUrl": "https://www.youtube-nocookie.com/embed/qWElBqsgOys?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/qWElBqsgOys/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_125",
    "videoId": "01frrpH3j9w",
    "title": "ஞானசாய் மகிமை, அற்புதம், பேரானந்தம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/01frrpH3j9w?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/01frrpH3j9w/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_126",
    "videoId": "yqiZ-H016Jc",
    "title": "ஓம் சாய் ராம்🙏 ஞான சாய் பாபாவின் மலர் ஆசிர்வாதம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/yqiZ-H016Jc?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/yqiZ-H016Jc/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_127",
    "videoId": "iikDdFdC2aw",
    "title": "ஓம் சாய்ராம் 🙏காணகண்கோடி வேண்டும், ஞான சாய் அற்புதம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/iikDdFdC2aw?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/iikDdFdC2aw/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_128",
    "videoId": "j1FfN9m_TGY",
    "title": "ஞான சாய்பாபாவின் தரிசனத்தை பெறுங்கள் உங்கள் வாழ்க்கையில் அற்புதம் நடக்கும்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/j1FfN9m_TGY?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/j1FfN9m_TGY/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_129",
    "videoId": "Aa4JVPMLeAA",
    "title": "நினைத்தது நடக்கும் அற்புதம்🙏",
    "embedUrl": "https://www.youtube-nocookie.com/embed/Aa4JVPMLeAA?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/Aa4JVPMLeAA/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_130",
    "videoId": "A8frvJ37ZE4",
    "title": "ஞானசாய் பாபா வின் அற்புதம் 🙏",
    "embedUrl": "https://www.youtube-nocookie.com/embed/A8frvJ37ZE4?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/A8frvJ37ZE4/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_131",
    "videoId": "Mlm8B_-CQho",
    "title": "துணி பூஜையின் மகிமை  🙏 சாய்நாதரின் அற்புதம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/Mlm8B_-CQho?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/Mlm8B_-CQho/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "pooja"
  },
  {
    "id": "short_132",
    "videoId": "oKkI8IxNhOQ",
    "title": "சமையல்காரரும்🙏 ஞான சாய் பாபாவும்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/oKkI8IxNhOQ?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/oKkI8IxNhOQ/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_133",
    "videoId": "WfTMDcwT8JU",
    "title": "வாழ்க்கையை மாற்றும் ஞான சாய்பாபா",
    "embedUrl": "https://www.youtube-nocookie.com/embed/WfTMDcwT8JU?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/WfTMDcwT8JU/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_134",
    "videoId": "lUa72VY3D6A",
    "title": "நினைத்தது நிறைவேறும் சத்திய நாராயண பூஜை🙏",
    "embedUrl": "https://www.youtube-nocookie.com/embed/lUa72VY3D6A?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/lUa72VY3D6A/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "pooja"
  },
  {
    "id": "short_135",
    "videoId": "tkLMGdF15vM",
    "title": "உணவே பிரம்மம்🙏 ஞான சாய் பாபா ஆசீர்வாதம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/tkLMGdF15vM?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/tkLMGdF15vM/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "annadanam"
  },
  {
    "id": "short_136",
    "videoId": "yBO1X4wZtH8",
    "title": "உணவே பிரம்மம்🙏 அன்னதானம், உணவின் மகிமை",
    "embedUrl": "https://www.youtube-nocookie.com/embed/yBO1X4wZtH8?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/yBO1X4wZtH8/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "annadanam"
  },
  {
    "id": "short_137",
    "videoId": "BaUgR1vYGTk",
    "title": "குழந்தை வரம் அருளும் ஞான சாய் பாபா",
    "embedUrl": "https://www.youtube-nocookie.com/embed/BaUgR1vYGTk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/BaUgR1vYGTk/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_138",
    "videoId": "qdlsdv1gRWM",
    "title": "உதி எனும் மருந்து🙏ஞானசாய்பாபா🌹",
    "embedUrl": "https://www.youtube-nocookie.com/embed/qdlsdv1gRWM?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/qdlsdv1gRWM/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_139",
    "videoId": "7Lmapjus_VA",
    "title": "கேட்டதைக் கொடுக்கும் ஞான சாய்பாபா",
    "embedUrl": "https://www.youtube-nocookie.com/embed/7Lmapjus_VA?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/7Lmapjus_VA/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_140",
    "videoId": "qXZBhSNAhL4",
    "title": "நினைத்தது நடக்கும் சத்யநாராயண பூஜை",
    "embedUrl": "https://www.youtube-nocookie.com/embed/qXZBhSNAhL4?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/qXZBhSNAhL4/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "pooja"
  },
  {
    "id": "short_141",
    "videoId": "kh1oOEkh7Yc",
    "title": "காணாமல் சான்றிதழ்கள் கிடைத்த அற்புதம் 🙏",
    "embedUrl": "https://www.youtube-nocookie.com/embed/kh1oOEkh7Yc?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/kh1oOEkh7Yc/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_142",
    "videoId": "aXQJZ67kJP8",
    "title": "சீரடி சாய்பாபா அலங்காரம்🙏 ஞான சாய் மந்திர் #saibaba",
    "embedUrl": "https://www.youtube-nocookie.com/embed/aXQJZ67kJP8?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/aXQJZ67kJP8/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_143",
    "videoId": "qlV9WixE6ZQ",
    "title": "உதியின் மகிமை 🙏 ஞான சாய் பாபா மந்திர்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/qlV9WixE6ZQ?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/qlV9WixE6ZQ/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_144",
    "videoId": "JsDaYEHW2xU",
    "title": "ஞான சாய் பாபாவின் அற்புதம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/JsDaYEHW2xU?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/JsDaYEHW2xU/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_145",
    "videoId": "psj_vyHktfE",
    "title": "வியாதிகளை எரிக்கும்  துனியின் மகிமை",
    "embedUrl": "https://www.youtube-nocookie.com/embed/psj_vyHktfE?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/psj_vyHktfE/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_146",
    "videoId": "dBES-_f49xs",
    "title": "மலர் ஆசிர்வாதம்,  ஞானசாய்பாபா #saibaba #shirdisaibabadevotees #love #tamil #astrology #sivan",
    "embedUrl": "https://www.youtube-nocookie.com/embed/dBES-_f49xs?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/dBES-_f49xs/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_147",
    "videoId": "AVXoqlqlo4E",
    "title": "விதியே சதி செய்தாலும், அதை, என் உதி சரி செய்யும். 🙏பாபா",
    "embedUrl": "https://www.youtube-nocookie.com/embed/AVXoqlqlo4E?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/AVXoqlqlo4E/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_148",
    "videoId": "gXQPG4F8DD8",
    "title": "கேட்ட வரம் அருளும் ஞான சாயிபாபா 🙏",
    "embedUrl": "https://www.youtube-nocookie.com/embed/gXQPG4F8DD8?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/gXQPG4F8DD8/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_149",
    "videoId": "nikKW4drGNw",
    "title": "ஸ்ரீ ஞான சாய்பாபா மந்திர்🙏 நினைத்தது நடக்கும் சத்தியம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/nikKW4drGNw?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/nikKW4drGNw/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_150",
    "videoId": "09EsLJIwCyE",
    "title": "ஞானசாய்பாபா மந்தீர் சனி பிரதோஷம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/09EsLJIwCyE?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/09EsLJIwCyE/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_151",
    "videoId": "0Vx-H40uLlU",
    "title": "ஸ்ரீ ஞான சாயி பாபா ஆசிர்வாதம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/0Vx-H40uLlU?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/0Vx-H40uLlU/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_152",
    "videoId": "x-1iv5LZhro",
    "title": "#ஞானசாய் பாபா# சத்தியநாராயண பூஜை# ஆசிர்வாதம்#ஞான",
    "embedUrl": "https://www.youtube-nocookie.com/embed/x-1iv5LZhro?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/x-1iv5LZhro/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "pooja"
  },
  {
    "id": "short_153",
    "videoId": "G0JetcYbGpI",
    "title": "# ஞான சாய்பாபா # தைப்பூச விழாவில்# சத்யநாராயண பூஜையில்# ஆசிர்வாதம் #t",
    "embedUrl": "https://www.youtube-nocookie.com/embed/G0JetcYbGpI?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/G0JetcYbGpI/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "pooja"
  },
  {
    "id": "short_154",
    "videoId": "CMXmDh9502Y",
    "title": "#ஞானசாய்பாபா மந்தீர்# தை பூசம் # வள்ளி தேவசேனா சுப்பிரமணிய சுவாமி ஆசிர்வாதம் #ஞான",
    "embedUrl": "https://www.youtube-nocookie.com/embed/CMXmDh9502Y?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/CMXmDh9502Y/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_155",
    "videoId": "KgemzhU4zB4",
    "title": "# ஸ்ரீ ஞான சாய்பாபா மந்திர் # சேஜ் ஆரத்தி தரிசனம்#ஞான",
    "embedUrl": "https://www.youtube-nocookie.com/embed/KgemzhU4zB4?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/KgemzhU4zB4/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "aarti"
  },
  {
    "id": "short_156",
    "videoId": "b6LI88Nnu_I",
    "title": "# ஞான சாய்பாபா # ஆங்கில வருடப் பிறப்பு ஆசிர்வாதம் #ஞான",
    "embedUrl": "https://www.youtube-nocookie.com/embed/b6LI88Nnu_I?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/b6LI88Nnu_I/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_157",
    "videoId": "CWaoIddbY74",
    "title": "# ஸ்ரீ ஞான சாய்பாபா மந்திர் # மாலை ஆரத்தி# ஆசிர்வாதம் #ஞான",
    "embedUrl": "https://www.youtube-nocookie.com/embed/CWaoIddbY74?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/CWaoIddbY74/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "aarti"
  },
  {
    "id": "short_158",
    "videoId": "d-TmbL0S1Mo",
    "title": "# ஸ்ரீ ஞான சாய்பாபா ஆசிர்வாதம் # மாலை ஆரத்தி தரிசனம்#ஞான",
    "embedUrl": "https://www.youtube-nocookie.com/embed/d-TmbL0S1Mo?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/d-TmbL0S1Mo/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "aarti"
  },
  {
    "id": "short_159",
    "videoId": "UxZ0qW_E2XQ",
    "title": "# ஞான சாய்பாபா மந்திர் # இரவு ஆரத்தி# ஞான சாய்பாபா ஆசீர்வாதம் #",
    "embedUrl": "https://www.youtube-nocookie.com/embed/UxZ0qW_E2XQ?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/UxZ0qW_E2XQ/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "aarti"
  },
  {
    "id": "short_160",
    "videoId": "gZBEt0Gfo4g",
    "title": "# ஞான சாய்பாபா மந்திர் # பாபா அபிஷேகம்# ஆசிர்வாதம் #",
    "embedUrl": "https://www.youtube-nocookie.com/embed/gZBEt0Gfo4g?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/gZBEt0Gfo4g/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_161",
    "videoId": "9jvMxc0Swec",
    "title": "# ஸ்ரீ ஞான சாய்பாபா மந்திர் # காசி விசாலாட்சி அம்பிகா சமேத விஸ்வநாதர் # பிரதோஷம்#ஞான",
    "embedUrl": "https://www.youtube-nocookie.com/embed/9jvMxc0Swec?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/9jvMxc0Swec/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_162",
    "videoId": "cUx2kjmqMwk",
    "title": "#Gnana sai baba mandir# baba blessings# Arathi#ஞான",
    "embedUrl": "https://www.youtube-nocookie.com/embed/cUx2kjmqMwk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/cUx2kjmqMwk/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_163",
    "videoId": "4p0bbf7tiRE",
    "title": "# ஸ்ரீ ஞான சாய்பாபா மந்திர் # மாலை ஆரத்தி# ஆசிர்வாதம் #ஞான",
    "embedUrl": "https://www.youtube-nocookie.com/embed/4p0bbf7tiRE?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/4p0bbf7tiRE/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "aarti"
  },
  {
    "id": "short_164",
    "videoId": "QIm0dfsw4F8",
    "title": "ஸ்ரீ ஞான சாய்பாபா மந்தீர்  is live",
    "embedUrl": "https://www.youtube-nocookie.com/embed/QIm0dfsw4F8?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/QIm0dfsw4F8/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_165",
    "videoId": "z0004eglvTg",
    "title": "#ஸ்ரீ ஞான சாய்பாபா மந்திர் # இரவு ஆரத்தி# ஆசிர்வாதம் பரிபூரணம் #",
    "embedUrl": "https://www.youtube-nocookie.com/embed/z0004eglvTg?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/z0004eglvTg/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "aarti"
  },
  {
    "id": "short_166",
    "videoId": "IemAUympBOM",
    "title": "#ஞான சாய்பாபா#கூட்டு பிரார்த்தனை#ஆசிர்வாதம்#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/IemAUympBOM?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/IemAUympBOM/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_167",
    "videoId": "YpUmT89FCqI",
    "title": "# ஞான சாயி பாபா# அபிஷேகம்# ஆசிர்வாதம் #",
    "embedUrl": "https://www.youtube-nocookie.com/embed/YpUmT89FCqI?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/YpUmT89FCqI/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_168",
    "videoId": "lx7yo6Kzy7A",
    "title": "# ஸ்ரீ ஞான சாய்பாபா மந்திர் # காகட ஆரத்தி # ஆசிர்வாதம் #ஞான",
    "embedUrl": "https://www.youtube-nocookie.com/embed/lx7yo6Kzy7A?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/lx7yo6Kzy7A/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "aarti"
  },
  {
    "id": "short_169",
    "videoId": "x9GGr_DryzM",
    "title": "#ஞானசாய்பாபா மந்தீர்# கோ- பூஜை# மஹாலக்ஷ்மி ஆசிர்வாதம் #",
    "embedUrl": "https://www.youtube-nocookie.com/embed/x9GGr_DryzM?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/x9GGr_DryzM/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "pooja"
  },
  {
    "id": "short_170",
    "videoId": "CWKMdBsFsmY",
    "title": "#ஞானசாய்பாபா #மலர் ஆசிர்வாதம்# நினைத்தது நடக்கும்#வெற்றி#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/CWKMdBsFsmY?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/CWKMdBsFsmY/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_171",
    "videoId": "TVn5pYRSMWo",
    "title": "# ஞான சாய்பாபா மந்தீர் # கோ- சாலா# பசுமடம் #ஞான",
    "embedUrl": "https://www.youtube-nocookie.com/embed/TVn5pYRSMWo?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/TVn5pYRSMWo/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_172",
    "videoId": "QB5dgL9zmTY",
    "title": "# ஸ்ரீ ஞான சாய்பாபா # ஆசிர்வாதம் # ஓம் சாய் ராம்#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/QB5dgL9zmTY?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/QB5dgL9zmTY/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_173",
    "videoId": "x7Sxb4N3OEM",
    "title": "# ஞான சாய் பாபா மந்திர் # சத்யநாராயண பூஜை # பௌர்ணமி # சத்தியமாக நினைத்தது நடக்கும்#ஞான",
    "embedUrl": "https://www.youtube-nocookie.com/embed/x7Sxb4N3OEM?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/x7Sxb4N3OEM/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "pooja"
  },
  {
    "id": "short_174",
    "videoId": "nVUtfhbvMPs",
    "title": "# ஸ்ரீ ஞான சாய்பாபா மந்திர் # சத்திய நாராயண பூஜை# பௌர்ணமி",
    "embedUrl": "https://www.youtube-nocookie.com/embed/nVUtfhbvMPs?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/nVUtfhbvMPs/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "pooja"
  },
  {
    "id": "short_175",
    "videoId": "xECy3QCArXk",
    "title": "# ஸ்ரீ ஞான சாய்பாபா மந்திர் # சிவபெருமான்# சோமவார பிரதோஷம் # ஆசிர்வாதம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/xECy3QCArXk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/xECy3QCArXk/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_176",
    "videoId": "Ab6cnriOT4o",
    "title": "# SRI GNANA SAI BABA #ASIRVATHAM# SHIRD SAIBABA#OM SAIRAM#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/Ab6cnriOT4o?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/Ab6cnriOT4o/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_177",
    "videoId": "pNYD7rOe4ag",
    "title": "#அழகன்#திருக்கல்யாணம்#புடவை வழங்குதல்#வேல்மாறல்#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/pNYD7rOe4ag?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/pNYD7rOe4ag/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_178",
    "videoId": "JnrYOiTikeI",
    "title": "#அழகன் முருகன் ஆசிர்வாதம்#ஞான சாய்பாபா #வெற்றிவேல்#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/JnrYOiTikeI?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/JnrYOiTikeI/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_179",
    "videoId": "i0NlRJPUYVs",
    "title": "#சஷ்டி 5 ஆம் நாள்# வள்ளி தேவசேனா கல்யாண சுப்ரமணியர்#ஆசிர்வாதம்#வெற்றிவேல் முருகனுக்கு அரோகரா#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/i0NlRJPUYVs?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/i0NlRJPUYVs/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_180",
    "videoId": "cFqZc-oXwEI",
    "title": "#சீரடி சாய்பாபா#ஞான சாய்பாபா மந்திர்# இரவு ஆரத்தி தரிசனம்# ஓம் சாய் ராம்#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/cFqZc-oXwEI?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/cFqZc-oXwEI/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "aarti"
  },
  {
    "id": "short_181",
    "videoId": "fSzzHbEkQdk",
    "title": "#ஞான சாய்பாபா மந்திர்# #வெற்றிவேல் முருகனுக்கு அரோகரா#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/fSzzHbEkQdk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/fSzzHbEkQdk/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_182",
    "videoId": "66QLxUtq1mc",
    "title": "#ஸ்ரீ வள்ளி தேவசேனா கல்யாண சுப்ரமணியர்# ஞான சாயி பாபா ஆசீர்வாதம் #கந்த சஷ்டி#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/66QLxUtq1mc?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/66QLxUtq1mc/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_183",
    "videoId": "EwqGIOxfiWI",
    "title": "October 18, 2025",
    "embedUrl": "https://www.youtube-nocookie.com/embed/EwqGIOxfiWI?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/EwqGIOxfiWI/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_184",
    "videoId": "i_Kv2zLqlhg",
    "title": "# ஸ்ரீ ஞான சாய்பாபா மந்திர்# தூப ஆரத்தி # Shirdi Sai Baba#Shirdi Sai Baba#Om Sai Ram#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/i_Kv2zLqlhg?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/i_Kv2zLqlhg/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "aarti"
  },
  {
    "id": "short_185",
    "videoId": "5bdly8ONZr0",
    "title": "#Gnana Sai Baba Mandir# Shirdi Sai Baba#Om Sai Ram#malar Ashirvatham##",
    "embedUrl": "https://www.youtube-nocookie.com/embed/5bdly8ONZr0?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/5bdly8ONZr0/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_186",
    "videoId": "yZC9IQXNOuI",
    "title": "##ஞான சாய்பாபா மந்திர் பாபா அபிஷேகம்#  Om Sai Ram",
    "embedUrl": "https://www.youtube-nocookie.com/embed/yZC9IQXNOuI?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/yZC9IQXNOuI/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_187",
    "videoId": "HdIxwSBV37U",
    "title": "#Gnana sai mandir# Shirdi Sai Baba# om sairam#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/HdIxwSBV37U?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/HdIxwSBV37U/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_188",
    "videoId": "sjgCXuGMHQQ",
    "title": "#Shirdi Sai Baba#.                   ##Gnana Sai Mandir#Om Sai Ram #",
    "embedUrl": "https://www.youtube-nocookie.com/embed/sjgCXuGMHQQ?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/sjgCXuGMHQQ/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_189",
    "videoId": "1Eg8gzqWKrg",
    "title": "#Om Sai Ram Om Sai Ram#. Gnana Sai Baba Mandir",
    "embedUrl": "https://www.youtube-nocookie.com/embed/1Eg8gzqWKrg?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/1Eg8gzqWKrg/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_190",
    "videoId": "kODTLZ3OFrY",
    "title": "#சத்யநாராயண பூஜை# ஞான சாயி பாபா மந்திர்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/kODTLZ3OFrY?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/kODTLZ3OFrY/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "pooja"
  },
  {
    "id": "short_191",
    "videoId": "iEF6xp6z2kI",
    "title": "#பாபா ஆசிர்வாதம்# Gnana sai baba mandir#om sairam#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/iEF6xp6z2kI?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/iEF6xp6z2kI/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_192",
    "videoId": "DU2dx6R_pDQ",
    "title": "#ஸ்ரீ ஞான சாய்பாபா ஆசீர்வாதம்#Om sairam #",
    "embedUrl": "https://www.youtube-nocookie.com/embed/DU2dx6R_pDQ?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/DU2dx6R_pDQ/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_193",
    "videoId": "YeV25Uw7wmM",
    "title": "##sri Gnana sai baba Asirvatham## OM SAIRAM#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/YeV25Uw7wmM?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/YeV25Uw7wmM/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_194",
    "videoId": "nK20dep8EUs",
    "title": "##Shirdi Sai Baba Arathi# Gnana Sai Baba Mandir#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/nK20dep8EUs?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/nK20dep8EUs/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_195",
    "videoId": "wV71mj3Rof4",
    "title": "#om sairam #Gnana saibaba blessings#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/wV71mj3Rof4?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/wV71mj3Rof4/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_196",
    "videoId": "WDrN2Ml_ido",
    "title": "#shirdi saibaba #ஞான சாய்பாபா மந்தீர்#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/WDrN2Ml_ido?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/WDrN2Ml_ido/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_197",
    "videoId": "E4GuOqg5CeA",
    "title": "#om sairam# shirdi saibaba# Gnana saibaba mandir#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/E4GuOqg5CeA?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/E4GuOqg5CeA/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_198",
    "videoId": "_pIWGOR7IBI",
    "title": "##Shirdi Sai Baba## Gnana Sai Baba flower blessings###",
    "embedUrl": "https://www.youtube-nocookie.com/embed/_pIWGOR7IBI?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/_pIWGOR7IBI/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_199",
    "videoId": "i8P8GCP18pU",
    "title": "##Shirdi Sai Baba## Gnana Sai Baba Mandir# Om sairam",
    "embedUrl": "https://www.youtube-nocookie.com/embed/i8P8GCP18pU?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/i8P8GCP18pU/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_200",
    "videoId": "oQqE3q-4amo",
    "title": "##   சீரடி சாய்பாபா#ஞான சாயி பாபா# நவராத்ரி கொழு  தரிசனம்##",
    "embedUrl": "https://www.youtube-nocookie.com/embed/oQqE3q-4amo?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/oQqE3q-4amo/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_201",
    "videoId": "JMR415iU6EE",
    "title": "##சீரடி சாய்பாபா###ஞான சாயி பாபாவும்## பசுவும் கொஞ்சும் அற்புதம்##",
    "embedUrl": "https://www.youtube-nocookie.com/embed/JMR415iU6EE?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/JMR415iU6EE/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_202",
    "videoId": "IyYZcERBbrQ",
    "title": "##சீரடி சாய்பாபா ஆர்த்தி ##ஞான சாய்பாபா ##",
    "embedUrl": "https://www.youtube-nocookie.com/embed/IyYZcERBbrQ?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/IyYZcERBbrQ/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_203",
    "videoId": "4AvcvvOhkRk",
    "title": "## ஸ்ரீ ஞான சாய்பாபா ஆசிர்வாதம்##சீரடி சாய்பாபா##அபிஷேகம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/4AvcvvOhkRk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/4AvcvvOhkRk/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_204",
    "videoId": "S6qM2xJ0-AY",
    "title": "#ஞான சாய்பாபா மந்திர்## அக்னி பிரதக்ஷணம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/S6qM2xJ0-AY?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/S6qM2xJ0-AY/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_205",
    "videoId": "GqbrYzNqQlI",
    "title": "##சீரடி சாய்பாபா மதிய ஆரத்தி##ஞான சாய் மந்திர்##",
    "embedUrl": "https://www.youtube-nocookie.com/embed/GqbrYzNqQlI?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/GqbrYzNqQlI/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "aarti"
  },
  {
    "id": "short_206",
    "videoId": "lEjhOS4Z6TQ",
    "title": "##ஞான சாயி பாபா ஆசிர்வாதம்##சீரடி சாய்பாபா",
    "embedUrl": "https://www.youtube-nocookie.com/embed/lEjhOS4Z6TQ?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/lEjhOS4Z6TQ/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_207",
    "videoId": "bYgQm40rF8s",
    "title": "##. ஸ்ரீ ஞான சாய்பாபா ஆசிர்வாதம் பரிபூரணம்##",
    "embedUrl": "https://www.youtube-nocookie.com/embed/bYgQm40rF8s?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/bYgQm40rF8s/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_208",
    "videoId": "CBcoAfCUP0M",
    "title": "## ஞான சாய் மந்தீர்## மலர் ஆசிர்வாதம் ,##  கான கண் கோடி வேண்டும்..",
    "embedUrl": "https://www.youtube-nocookie.com/embed/CBcoAfCUP0M?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/CBcoAfCUP0M/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_209",
    "videoId": "z5JKcQGgoT0",
    "title": "#Gnana sai baba 🙏💗Om Sai Ram 💗🙏#saibaba #shirdi #shirdisaibaba #",
    "embedUrl": "https://www.youtube-nocookie.com/embed/z5JKcQGgoT0?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/z5JKcQGgoT0/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_210",
    "videoId": "30-IRniH7gI",
    "title": "## சீரடி சாய்பாபா##ஞான சாயி பாபா ஆசிர்வாதம்##",
    "embedUrl": "https://www.youtube-nocookie.com/embed/30-IRniH7gI?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/30-IRniH7gI/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_211",
    "videoId": "I7wehiTajNk",
    "title": "##விநாயகர் ஆசிர்வாதம்##",
    "embedUrl": "https://www.youtube-nocookie.com/embed/I7wehiTajNk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/I7wehiTajNk/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_212",
    "videoId": "E2etVfLjAak",
    "title": "# ஞான சாய்பாபா மந்தீர்## சீரடி சாய்பாபா",
    "embedUrl": "https://www.youtube-nocookie.com/embed/E2etVfLjAak?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/E2etVfLjAak/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_213",
    "videoId": "YDS0bn2Vat0",
    "title": "## சீரடி சாய்பாபா#சீரடி சாய்பாபா##ஞான சாய் மந்தீர்##",
    "embedUrl": "https://www.youtube-nocookie.com/embed/YDS0bn2Vat0?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/YDS0bn2Vat0/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_214",
    "videoId": "iEHmT3OGqkk",
    "title": "##சீரடி சாய்பாபா##ஸ்ரீ ஞான சாயி பாபா மந்திர்##",
    "embedUrl": "https://www.youtube-nocookie.com/embed/iEHmT3OGqkk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/iEHmT3OGqkk/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_215",
    "videoId": "9sR06Zt3Z5c",
    "title": "# ஸ்ரீ ஞான சாய்பாபா ஆசிர்வாதம்### சத்யநாராயண பெருமான் ஆசிர்வாதம்##",
    "embedUrl": "https://www.youtube-nocookie.com/embed/9sR06Zt3Z5c?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/9sR06Zt3Z5c/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_216",
    "videoId": "wHYdldYRXy0",
    "title": "##ஞான சாய்பாபா ##பாபாவை கொஞ்சும் பசு ##",
    "embedUrl": "https://www.youtube-nocookie.com/embed/wHYdldYRXy0?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/wHYdldYRXy0/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_217",
    "videoId": "cfQeutH7kHs",
    "title": "## ஞான சாய்பாபா ஆசிர்வாதம்##",
    "embedUrl": "https://www.youtube-nocookie.com/embed/cfQeutH7kHs?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/cfQeutH7kHs/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_218",
    "videoId": "FVHIBAXFmqk",
    "title": "#ஸ்ரீ ஞான சாயி பாபா இரவு ஆரத்தி ஆசிர்வாதம்###",
    "embedUrl": "https://www.youtube-nocookie.com/embed/FVHIBAXFmqk?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/FVHIBAXFmqk/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "aarti"
  },
  {
    "id": "short_219",
    "videoId": "VMu_S769RLA",
    "title": "#ஸ்ரீ ஞான சாய்பாபா மந்தீர்## பாபாவை வணங்க வரும் பசு#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/VMu_S769RLA?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/VMu_S769RLA/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_220",
    "videoId": "ea-f4wdGajg",
    "title": "## ஸ்ரீ ஞான சாய்பாபா ஆசிர்வாதம்##",
    "embedUrl": "https://www.youtube-nocookie.com/embed/ea-f4wdGajg?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/ea-f4wdGajg/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_221",
    "videoId": "KdZwManNNY4",
    "title": "##ஞான சாய்பாபா ஆசிர்வாதம்##",
    "embedUrl": "https://www.youtube-nocookie.com/embed/KdZwManNNY4?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/KdZwManNNY4/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_222",
    "videoId": "xvkbZ694Hc8",
    "title": "# கோகுலாஷ்டமி#ஞான சாய்பாபா மந்திர் #",
    "embedUrl": "https://www.youtube-nocookie.com/embed/xvkbZ694Hc8?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/xvkbZ694Hc8/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_223",
    "videoId": "jMeU17lotMc",
    "title": "# சீரடி சாய்பாபா#ஞான சாய்பாபா மந்திர் சேஜ் ஆரத்தி#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/jMeU17lotMc?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/jMeU17lotMc/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "aarti"
  },
  {
    "id": "short_224",
    "videoId": "tmuULNXDNkI",
    "title": "#அழகன்முருகனின்மலர் ஆசிர்வதம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/tmuULNXDNkI?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/tmuULNXDNkI/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_225",
    "videoId": "pSvuosXsyQM",
    "title": "#shird sai baba #Gnana sai baba Asirvatham###",
    "embedUrl": "https://www.youtube-nocookie.com/embed/pSvuosXsyQM?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/pSvuosXsyQM/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_226",
    "videoId": "C5GziJyNYPU",
    "title": "##shird sai baba #sri Gnana sai baba Asirvatham , #",
    "embedUrl": "https://www.youtube-nocookie.com/embed/C5GziJyNYPU?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/C5GziJyNYPU/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_227",
    "videoId": "zcF86D-ulQo",
    "title": "##சீரடி சாயி பாபா# ஸ்ரீ ஞான சாய்பாபா ஆசிர்வாதம்#",
    "embedUrl": "https://www.youtube-nocookie.com/embed/zcF86D-ulQo?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/zcF86D-ulQo/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_228",
    "videoId": "TTbk2kEFQBQ",
    "title": "ஶ்ரீ ஞான சாய்பாபா ஆலயத்தில் இன்று நடைபெற்ற #சங்கடஹர  சதுர்த்தி பூஜை",
    "embedUrl": "https://www.youtube-nocookie.com/embed/TTbk2kEFQBQ?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/TTbk2kEFQBQ/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "pooja"
  },
  {
    "id": "short_229",
    "videoId": "B5CnUMw3tyQ",
    "title": "#ஆடி செவ்வாய் முருகபெருமானின் மலர் பரிபூரணம் ஆசிர்வாதம்,###",
    "embedUrl": "https://www.youtube-nocookie.com/embed/B5CnUMw3tyQ?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/B5CnUMw3tyQ/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_230",
    "videoId": "f0tz888FpqE",
    "title": "#  ஸ்ரீ ஞான சாய்பாபா புஷ்பம் ஆசிர்வாதம்,###",
    "embedUrl": "https://www.youtube-nocookie.com/embed/f0tz888FpqE?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/f0tz888FpqE/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_231",
    "videoId": "WRSXuiVsRXE",
    "title": "#ஸ்ரீஞானசாயிபாபாஆசிர்வாதம் பரிபூரணம்",
    "embedUrl": "https://www.youtube-nocookie.com/embed/WRSXuiVsRXE?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/WRSXuiVsRXE/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_232",
    "videoId": "I_JUiyVGnkU",
    "title": "June 23, 2025",
    "embedUrl": "https://www.youtube-nocookie.com/embed/I_JUiyVGnkU?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/I_JUiyVGnkU/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_233",
    "videoId": "ERP9FqzrYuM",
    "title": "June 23, 2025",
    "embedUrl": "https://www.youtube-nocookie.com/embed/ERP9FqzrYuM?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/ERP9FqzrYuM/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  },
  {
    "id": "short_234",
    "videoId": "zctYhQF2sJA",
    "title": "April 15, 2024",
    "embedUrl": "https://www.youtube-nocookie.com/embed/zctYhQF2sJA?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/zctYhQF2sJA/hqdefault.jpg",
    "badge": "✨ SACRED",
    "category": "darshan"
  },
  {
    "id": "short_235",
    "videoId": "LiIfpi190Jg",
    "title": "April 13, 2024",
    "embedUrl": "https://www.youtube-nocookie.com/embed/LiIfpi190Jg?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/LiIfpi190Jg/hqdefault.jpg",
    "badge": "🔴 LIVE",
    "category": "darshan"
  },
  {
    "id": "short_236",
    "videoId": "xKfEJd_QTUU",
    "title": "May 9, 2023",
    "embedUrl": "https://www.youtube-nocookie.com/embed/xKfEJd_QTUU?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1",
    "thumbnailUrl": "https://i.ytimg.com/vi/xKfEJd_QTUU/hqdefault.jpg",
    "badge": "🪔 DIVINE",
    "category": "darshan"
  }
];

/**
 * Format any YouTube Shorts URL or ID into a clean embed URL
 */
export const formatShortEmbedUrl = (urlOrId) => {
  if (!urlOrId) return "";
  let id = urlOrId.trim();
  if (id.includes("/shorts/")) {
    id = id.split("/shorts/")[1].split("?")[0].split("&")[0];
  } else if (id.includes("youtu.be/")) {
    id = id.split("youtu.be/")[1].split("?")[0];
  } else if (id.includes("watch?v=")) {
    id = id.split("watch?v=")[1].split("&")[0];
  } else if (id.includes("/embed/")) {
    id = id.split("/embed/")[1].split("?")[0];
  }
  return `https://www.youtube-nocookie.com/embed/${id}?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1`;
};

const parseISO = (dur) => {
  if (!dur) return 0;
  const m = dur.match(/PT(?:(\d+)M)?(?:(\d+)S)?/);
  if (!m) return 0;
  return (parseInt(m[1] || 0) * 60) + parseInt(m[2] || 0);
};

/**
 * Fetch shorts with YouTube API pagination support
 */
export const fetchLatestShorts = async (limit = 10) => {
  try {
    const apiKey = process.env.REACT_APP_YOUTUBE_API_KEY;
    if (apiKey) {
      const channelRes = await fetch(
        `https://www.googleapis.com/youtube/v3/channels?part=contentDetails&forHandle=${YOUTUBE_CHANNEL_HANDLE}&key=${apiKey}`
      );
      const channelData = await channelRes.json();
      const uploadsPlaylistId = channelData?.items?.[0]?.contentDetails?.relatedPlaylists?.uploads;

      if (uploadsPlaylistId) {
        let fetchedItems = [];
        let nextPageToken = "";
        let pagesToFetch = limit > 50 ? Math.ceil(limit / 50) : 1;
        let pageCount = 0;

        do {
          const playlistUrl = `https://www.googleapis.com/youtube/v3/playlistItems?part=snippet&playlistId=${uploadsPlaylistId}&maxResults=50${nextPageToken ? `&pageToken=${nextPageToken}` : ""}&key=${apiKey}`;
          const playlistRes = await fetch(playlistUrl);
          const playlistData = await playlistRes.json();

          if (playlistData?.items?.length > 0) {
            const videoIds = playlistData.items.map(item => item.snippet.resourceId.videoId).join(",");
            const detailsRes = await fetch(
              `https://www.googleapis.com/youtube/v3/videos?part=contentDetails,snippet&id=${videoIds}&key=${apiKey}`
            );
            const detailsData = await detailsRes.json();

            if (detailsData?.items?.length > 0) {
              detailsData.items.forEach((item) => {
                const dur = item.contentDetails?.duration || "";
                const sec = parseISO(dur);
                if (sec <= 95 && sec > 0) {
                  fetchedItems.push({
                    id: item.id,
                    videoId: item.id,
                    title: item.snippet.title,
                    embedUrl: `https://www.youtube-nocookie.com/embed/${item.id}?autoplay=1&mute=0&controls=1&rel=0&playsinline=1&enablejsapi=1`,
                    thumbnailUrl: `https://i.ytimg.com/vi/${item.id}/hqdefault.jpg`,
                    badge: fetchedItems.length % 3 === 0 ? "🔴 LIVE" : (fetchedItems.length % 3 === 1 ? "🪔 DIVINE" : "✨ SACRED"),
                    category: (item.snippet.title.includes("அன்னதான") || item.snippet.title.includes("உணவே") || item.snippet.title.includes("பிரம்மம்") || item.snippet.title.includes("சாப்பாடு")) ? "annadanam" : (item.snippet.title.includes("ஆரத்தி") ? "aarti" : (item.snippet.title.includes("பூஜை") || item.snippet.title.includes("ஹோமம்") ? "pooja" : "darshan"))
                  });
                }
              });
            }
            nextPageToken = playlistData.nextPageToken;
          } else {
            break;
          }
          pageCount++;
        } while (nextPageToken && pageCount < pagesToFetch && fetchedItems.length < limit);

        if (fetchedItems.length > 0) {
          return fetchedItems.slice(0, limit);
        }
      }
    }
  } catch (err) {
    console.warn("YouTube API Fetch Warning, using complete default shorts:", err.message);
  }
  return DEFAULT_SHORTS.slice(0, limit);
};

/**
 * Fetch all shorts for full gallery view
 */
export const fetchAllShorts = async () => {
  return fetchLatestShorts(300);
};
